import { useContext } from 'react';
import { SelectedTariffContext } from 'src/products/tariffSummary/SelectedTariffContext';

export const useSelectedTariff = () => {
  return useContext(SelectedTariffContext);
};
